import React from 'react';

// Form

import { 
    useFormContext 
} from "react-hook-form"

// Styles

import {
    ErrorText,
    RedTint
} from '../../../Styles/BaseStyles'

import { 
    SectionDiv, 
    HeaderDiv, 
    FormDiv, 
    SectionHeader, 
    ApplicationRowDiv,
    LeftApplicationDiv,
    RightApplicationDiv,
    ApplicationHeader,
    InputField,
} from  '../../../Styles/Components/ApplicationSectionStyles'

// Utilities

import * as StringTools from '../../../Utilities/StringTools'

// Redux dispatch and selector

import { useSelector } from "react-redux"

function AppDetailsSection(props){

    const { register, errors } = useFormContext()

    const locked = useSelector(state => state.appViewer.locked)

    function retrieveName(sectionName){
        var ind = sectionName.indexOf("-details-section")
        var name = sectionName.substring(0,ind)
        var upperName = StringTools.capitalizeFirstLetter(name)
        return upperName
    }

    var sectionName = retrieveName(props.name)

    return (
        <SectionDiv id = {props.name}>
            <HeaderDiv>
                <SectionHeader>{sectionName+" Details"}</SectionHeader>
            </HeaderDiv>
            <FormDiv>
                <ApplicationRowDiv>
                    <LeftApplicationDiv>
                        <ApplicationHeader>Name<RedTint>*</RedTint></ApplicationHeader>
                        <InputField 
                            type="text" name="application_details.name" placeholder={sectionName+" Name"} 
                            ref={
                                register({
                                    required: {
                                        value: true,
                                        message: 'required field'
                                    },
                                    maxLength: {
                                        value: 260,
                                        message: 'exceeds 260 character limit'
                                    },
                                    pattern: {
                                        value: /^[\w\-\. ]+$/,
                                        message: 'invalid character usage'
                                    }
                                })
                            }
                            readOnly={locked}
                        />
                        {errors['application_details'] != null && errors['application_details']['name'] != null && <ErrorText p={0} ml={0} mr={0} mt="0.25rem">{'*'+errors['application_details']['name']['message']}</ErrorText>} 
                    </LeftApplicationDiv>
                    <RightApplicationDiv>
                        <ApplicationHeader>Tags<RedTint>*</RedTint></ApplicationHeader>
                        <InputField 
                            type="text" name="application_details.tags" placeholder={sectionName+" Tags (separate by commas)"} 
                            ref={
                                register({
                                    required: {
                                        value: true,
                                        message: 'required field'
                                    },
                                    maxLength: {
                                        value: 30,
                                        message: 'exceeds 30 character limit'
                                    },
                                    pattern: {
                                        value: /^[a-zA-Z0-9+#\-() \/\[\]]+\s*(,\s*[a-zA-Z0-9+#\-() \/\[\]]+)*$/,
                                        message: 'invalid format or character usage'
                                    }
                                })
                            }
                            readOnly={locked}
                        />
                        {errors['application_details'] != null && errors['application_details']['tags'] != null && <ErrorText p={0} ml={0} mr={0} mt="0.25rem">{'*'+errors['application_details']['tags']['message']}</ErrorText>} 
                    </RightApplicationDiv>
                </ApplicationRowDiv>
            </FormDiv>
        </SectionDiv>
    )
}

export default AppDetailsSection